import { Injectable } from '@angular/core';
import { Adapter } from 'src/app/core/adapter';
import { Model } from 'src/app/core/models/model';


export enum AccessLevel {
    Observer = 'observer',
    Admin = 'admin'
};

class UserRequest {
    constructor(
        public id: number,
        public email: string
    ) { }
}

export class AccessRequest implements Model {
    constructor(
        public user: UserRequest,
        public right: string
    ) { }

    public get isObserver() {
        return this.right === AccessLevel.Observer;
    }

    public get isAdmin() {
        return this.right === AccessLevel.Admin;
    }
}



@Injectable({
    providedIn: 'root'
})
export class AccessRequestAdapter implements Adapter<AccessRequest> {

    adapt(item: any): AccessRequest {
        return new AccessRequest(
            item.user ? new UserRequest(item.user.id, item.user.email) : null,
            item.user_right ? item.user_right.label : null
        );
    }
}